import { cookies } from './cookies';

const storagePrefix = 'flowscale_hub_';

const storage = {
  getOnboardingState: () => {
    return JSON.parse(window.localStorage.getItem('onboarding_state') as string);
  },
  setOnboardingState: (onboarding_state: string) => {
    window.localStorage.setItem('onboarding_state', JSON.stringify(onboarding_state));
  },
  clearOnboardingState: () => {
    window.localStorage.removeItem('onboarding_state');
  },
  getMigrationStatus: () => {
    return JSON.parse(window.localStorage.getItem(`migration_status`) as string);
  },
  setMigrationStatus: (migration_status: string) => {
    window.localStorage.setItem(`migration_status`, JSON.stringify(migration_status));
  },
  clearMigrationStatus: () => {
    window.localStorage.removeItem(`migration_status`);
  },
  getTeam: () => {
    return JSON.parse(window.localStorage.getItem(`${storagePrefix}team`) as string);
  },
  setTeam: (teamId: string) => {
    window.localStorage.setItem(`${storagePrefix}team`, JSON.stringify(teamId));
  },
  clearTeam: () => {
    window.localStorage.removeItem(`${storagePrefix}team`);
  },
  getAccessToken: (): string | null =>
    JSON.parse(window.sessionStorage.getItem(`${storagePrefix}access_token`) as string),
  setAccessToken: (token: string) =>
    window.sessionStorage.setItem(`${storagePrefix}access_token`, JSON.stringify(token)),
  getRefreshToken: () => {
    return JSON.parse(window.localStorage.getItem(`${storagePrefix}refresh_token`) as string);
  },
  setRefreshToken: (token: string) => {
    window.localStorage.setItem(`${storagePrefix}refresh_token`, JSON.stringify(token));
  },
  getIdToken: () => {
    return JSON.parse(window.sessionStorage.getItem(`${storagePrefix}id_token`) as string);
  },
  setIdToken: (token: string) => {
    window.sessionStorage.setItem(`${storagePrefix}id_token`, JSON.stringify(token));
  },

  getIsHasProjectAccess: () => {
    return JSON.parse(window.sessionStorage.getItem('is_has_access') as string);
  },
  setIsHasProjectAccess: (isViewOnly: boolean) => {
    window.sessionStorage.setItem('is_has_access', JSON.stringify(isViewOnly));
  },
  clearIsHasProjectAccess: () => {
    window.sessionStorage.removeItem('is_has_access');
    window.sessionStorage.removeItem('redirect_project_id');
  },

  // ComfyOrg API Key methods now use cookies
  getComfyOrgAPIKey: () => {
    return cookies.getComfyOrgAPIKey();
  },
  setComfyOrgAPIKey: (comfy_api_key: string) => {
    cookies.setComfyOrgAPIKey(comfy_api_key);
  },
  clearComfyOrgAPIKey: () => {
    cookies.clearComfyOrgAPIKey();
  },

  clearAllTokens: () => {
    window.sessionStorage.removeItem(`${storagePrefix}access_token`);
    window.localStorage.removeItem(`${storagePrefix}refresh_token`);
    window.sessionStorage.removeItem(`${storagePrefix}id_token`);
    window.localStorage.removeItem(`${storagePrefix}team`);
    window.localStorage.removeItem(`migration_status`);
    window.sessionStorage.removeItem('is_has_access');
    window.sessionStorage.removeItem('redirect_project_id');
    window.localStorage.removeItem('onboarding_state');
    // Clear ComfyOrg API key from cookies
    cookies.clearComfyOrgAPIKey();
  },

  // Keeping these for backward compatibility
  getToken: () => {
    return JSON.parse(window.sessionStorage.getItem(`${storagePrefix}access_token`) as string);
  },
  setToken: (token: string) => {
    window.sessionStorage.setItem(`${storagePrefix}access_token`, JSON.stringify(token));
  },
  clearToken: () => {
    storage.clearAllTokens();
  },
};

export default storage;
